import { useContext } from 'react';
import { SelectedDeviationContext } from '../SelectedDeviationContext';

// Custom hook to use the context
export const useSelectedDeviation = () => {
  const context = useContext(SelectedDeviationContext);
  if (!context) {
    throw new Error('useSelectedDeviation must be used within a SelectedDeviationProvider');
  }
  return context;
};
